import { render } from "./DocumentStatusList.vue?vue&type=template&id=7e5c8996&ts=true"
import script from "./DocumentStatusList.vue?vue&type=script&lang=ts"
export * from "./DocumentStatusList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__